import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { Footer } from '../components/Footer';
import { ScrollToTop } from '../components/ScrollToTop';
export function LocalInsightsPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const insights = [{
    title: 'Best Time to Visit',
    content: "Nairobi enjoys pleasant weather year-round, but the best times are January-February and July-October when it's dry and sunny. The rainy seasons (March-May and November-December) bring lush greenery but can make some activities challenging."
  }, {
    title: 'Getting Around',
    content: 'Taxis and ride-sharing apps (Uber, Bolt) are the safest and most convenient options. Matatus (minibuses) are cheap but can be crowded. Traffic is heavy during rush hours (7-9 AM and 5-7 PM), so plan accordingly.'
  }, {
    title: 'Safety Tips',
    content: 'Nairobi is generally safe for tourists, but stay vigilant. Avoid displaying valuables, use reputable transportation, and stick to well-lit areas at night. Keep copies of important documents and use hotel safes.'
  }, {
    title: 'Money & Payments',
    content: 'The Kenyan Shilling (KES) is the local currency. ATMs are widely available. Most hotels and restaurants accept cards, but carry cash for markets and small vendors. M-Pesa mobile money is ubiquitous.'
  }, {
    title: 'Language',
    content: 'English and Swahili are official languages. Most Nairobians speak English fluently. Learning basic Swahili phrases (jambo, asante, karibu) is appreciated and enhances your experience.'
  }, {
    title: 'Tipping Etiquette',
    content: "Tipping is customary but not mandatory. 10% is standard in restaurants if service charge isn't included. Tip tour guides, drivers, and hotel staff based on service quality."
  }, {
    title: 'Dress Code',
    content: 'Nairobi is cosmopolitan and casual. Dress modestly when visiting religious sites. Layers are useful as mornings and evenings can be cool. Comfortable walking shoes are essential.'
  }, {
    title: 'Health & Vaccinations',
    content: 'Yellow fever vaccination is required if coming from endemic countries. Malaria risk is low in Nairobi but present in surrounding areas. Drink bottled water and use sunscreen at high altitude.'
  }];
  return <div className="min-h-screen bg-white" data-id="element-1167">
      {/* Hero */}
      <div className="border-b border-gray-200" data-id="element-1168">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-20 md:py-32" data-id="element-1169">
          <motion.div initial={{
          y: 20,
          opacity: 0
        }} animate={{
          y: 0,
          opacity: 1
        }} transition={{
          duration: 0.6
        }} className="max-w-3xl" data-id="element-1170">
            <h1 className="text-5xl md:text-7xl font-semibold text-charcoal mb-6 leading-tight" data-id="element-1171">
              Local Insights
            </h1>
            <p className="text-xl md:text-2xl text-gray-600 leading-relaxed" data-id="element-1172">
              Essential tips and insider knowledge to help you navigate Nairobi
              like a local.
            </p>
          </motion.div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16" data-id="element-1173">
        <div className="grid md:grid-cols-2 gap-8" data-id="element-1174">
          {insights.map((insight, index) => <motion.div key={insight.title} className="border border-gray-200 p-8" initial={{
          y: 20,
          opacity: 0
        }} whileInView={{
          y: 0,
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} data-id="element-1175">
              <h2 className="text-xl font-semibold text-charcoal mb-4" data-id="element-1176">
                {insight.title}
              </h2>
              <p className="text-gray-700 leading-relaxed" data-id="element-1177">{insight.content}</p>
            </motion.div>)}
        </div>
      </div>

      <ScrollToTop data-id="element-1178" />
      <Footer data-id="element-1179" />
    </div>;
}